import { useDispatch } from 'react-redux';
import { setActiveTasksPage } from '../../../actions/admin.actions';
import {
  Box,
  ChevronDownIcon,
  Flex,
  HbFilter,
  Menu,
  MenuButton,
  MenuFuseHighlight,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  MenuSearchBox,
  MenuSearchBoxOption,
  MenuToolbar,
  VirtualizedList,
} from '@cdl/heartbeat-react';

type Props = {
  options: MenuSearchBoxOption[];
  type: string;
  selectedOptions: string[];
  onChange: (selectedData: string[]) => void;
};

export const CategoriesFilter: React.FC<Props> = ({
  options,
  type,
  selectedOptions,
  onChange,
}) => {
  const dispatch = useDispatch();

  const handleSelectedChange = (optionCodes: string | string[]) => {
    const selectedData = Array.isArray(optionCodes)
      ? optionCodes
      : [optionCodes];
    onChange(selectedData);
    dispatch(setActiveTasksPage({ page: 1 }));
  };

  return (
    <Box>
      <Menu closeOnSelect={false} variant='virtual' matchWidth>
        <MenuButton
          as={HbFilter}
          variant='secondary'
          textAlign='left'
          fontWeight='regular'
          rightIcon={<ChevronDownIcon />}
          value={selectedOptions.map(
            (selected: string) =>
              options.find((el) => el.value === selected)?.displayValue || '',
          )}
        >
          {type}
        </MenuButton>
        <MenuList maxWidth='unset'>
          <MenuSearchBox options={options} placeholder='Search...'>
            {(filteredOptions) => (
              <Flex flexDirection='column'>
                <VirtualizedList
                  rowHeight={35}
                  containerHeight={300}
                  size={filteredOptions.length || options.length}
                >
                  {(virtualItems) => (
                    <MenuOptionGroup
                      type='checkbox'
                      value={selectedOptions}
                      onChange={(value) => {
                        handleSelectedChange(value);
                      }}
                    >
                      {virtualItems.map(({ index, key, style }) => {
                        if (filteredOptions.length > 0) {
                          const fuseOption = filteredOptions[index];
                          return (
                            <MenuItemOption
                              value={fuseOption.item.value}
                              key={key}
                              style={style}
                            >
                              <MenuFuseHighlight
                                fallback={fuseOption.item.value}
                                hit={fuseOption}
                              />
                            </MenuItemOption>
                          );
                        }
                        const { value, displayValue } = options[index];
                        return (
                          <MenuItemOption value={value} key={key} style={style}>
                            {displayValue}
                          </MenuItemOption>
                        );
                      })}
                    </MenuOptionGroup>
                  )}
                </VirtualizedList>
                <MenuToolbar
                  clearLabel='Clear'
                  cancelLabel='Cancel'
                  applyLabel='Apply'
                  onClear={() => {
                    handleSelectedChange([]);
                  }}
                />
              </Flex>
            )}
          </MenuSearchBox>
        </MenuList>
      </Menu>
    </Box>
  );
};
